// Protect List — what the user is protecting.
// Categories are presets; labels are free-form text.

import {
  Users,
  ShieldCheck,
  Leaf,
  Briefcase,
  Sparkle,
  Sunrise,
  Home,
  Heart,
} from "lucide-react";

export const PROTECT_CATEGORIES = {
  people: {
    id: "people",
    label: "People & relationships",
    icon: Users,
    accent: "#5B3954",
    placeholder: "Sophie · Mom · Sam",
    examples: ["Sophie", "Mom", "Sam"],
  },
  dignity: {
    id: "dignity",
    label: "Dignity & self-respect",
    icon: ShieldCheck,
    accent: "#7A5C63",
    placeholder: "How I want to look back at myself",
    examples: ["My self-respect", "The way I treat people"],
  },
  peace: {
    id: "peace",
    label: "Peace & calm",
    icon: Leaf,
    accent: "#4A6B5D",
    placeholder: "A quiet morning",
    examples: ["My mornings", "Quiet evenings"],
  },
  stability: {
    id: "stability",
    label: "Stability & work",
    icon: Briefcase,
    accent: "#5C4A57",
    placeholder: "My job · My housing",
    examples: ["My job", "My housing", "Financial stability"],
  },
  sobriety: {
    id: "sobriety",
    label: "Sobriety & goals",
    icon: Sparkle,
    accent: "#8E6C88",
    placeholder: "Tomorrow morning clear-headed",
    examples: ["Tomorrow morning clear-headed", "30 days"],
  },
  future: {
    id: "future",
    label: "Future self & dreams",
    icon: Sunrise,
    accent: "#C4A16A",
    placeholder: "The version of me I'm becoming",
    examples: ["Future me", "The book I want to write"],
  },
  home: {
    id: "home",
    label: "Pets & home",
    icon: Home,
    accent: "#8A7985",
    placeholder: "My dog Charlie",
    examples: ["Charlie", "My plants", "My home"],
  },
  safety: {
    id: "safety",
    label: "Emotional safety",
    icon: Heart,
    accent: "#5B3954",
    placeholder: "My nervous system",
    examples: ["My nervous system", "How I sleep"],
  },
};

export const PROTECT_CATEGORY_ORDER = [
  "people",
  "dignity",
  "peace",
  "stability",
  "sobriety",
  "future",
  "home",
  "safety",
];

// Templates that read naturally with a label slotted in.
export const PERSONALIZED_TEMPLATES = [
  (label) => `You said ${label} matters.`,
  (label) => `Protect ${label} tonight.`,
  (label) => `${label} is worth protecting tonight.`,
  (label) => `Pause before risking ${label}.`,
  (label) => `${label} — that's what tomorrow-you is asking you to protect.`,
  (label) => `Tonight, what does ${label} need from you?`,
  (label) => `Your ${label.toLowerCase()} doesn't need you to disappear.`,
];
